module.exports = __webpack_public_path__ + "img/scene_spring_backlight@2x.131643ca.png";